<template>

  <body>
    <div>
      <my-header> </my-header>
      <!--内容-->
      <div class="mainWrap">
        <div class="main proWrap">

          <div class="breadCrumbs">
            <h3>{{productname}}</h3>
            <span>
              <a>首页</a> &gt;
              <router-link to="/MixedCellSeries">
            <a>产品</a> &gt;
            </router-link>  
              <a @click="returnmix()">{{productname}}</a> &gt;
              <em>{{productlist.title}}</em>
            </span>
          </div>

          <!--内容开始-->
          <div class="content">

            <div class="cr_protab">
              <a class="cur">选择颜色</a>
              <a class="linkNext"
                 @click="box()">选择线材和包装盒</a>
              <a>确认购买</a>
            </div>

            <div class="probuy_onecon Ywwtab" v-show='loading'>

              <div class="Ywwtit">
                <span v-for="(item,index) in earType"
                      :class="{'cur':index==ear}"
                      :key="index"
                      @click="handleEarType(index,item.earid)">{{item.earname}}颜色</span>
              </div>
              <!--	选择颜色-->
              <dl>
                <dt>
                  <div class="Ywwlater">
                    <div class="Ywwlaterlib">
                      <p class="crImgLagre YwwpicRight.image">
                        <img :src=" httpurl +YwwpicRight.image" />
                      </p>
                      <p class="crImgLagre YwwLagre">
                        <img :src=" httpurl +YwwLagre.image" />
                      </p>
                    </div>
                    <span class="Ywwmoren del_float clearfix">￥{{addprice}}</span>
                  </div>
                  <div class="Ywwcen-container">

                    <div class="Ywwcen YwwcenOne"
                         v-show="earid==1">
                      <div class="probuy_onecon_left">
                        <div class="crColorTab crColorTabOne">
                          <a v-for="(item,index) in LcolorType"
                             :class="{'cur':index==type}"
                             :key="index"
                             @click="handleColorType(index,item.classid)">{{item.name}}</a>
                        </div>
                        <div class="pro_selcolor YwwLeft YwwBlock"
                             v-if="isLcolorTypeshow">
                          <span rel="0.00"
                                v-for="(item,index) in LcolorType[type].list"
                                @click="chooseColor(index,item)"
                                :key="index"
                                :class="{'cur':item.imageid==number1}">
                            <img :src="httpurl+item.image"
                                 :title="item.title"
                                 width="65"
                                 height="65">
                          </span>

                        </div>
                        <p class="pro_cankao">*颜色仅供参考，以实物为准。</p>
                      </div>
                    </div>
                    <div class="crColorTab crColorTabTwo"
                         v-show="earid==2">
                      <div class="probuy_onecon_left">
                        <div class="crColorTab crColorTabOne">
                          <a v-for="(item,index) in RcolorType"
                             :key="index"
                             :class="{'cur':index==type2}"
                             @click="handleColorType2(index,item.classid)">{{item.name}}</a>
                        </div>
                        <!--半透明色-->
                        <div class="pro_selcolor YwwLeft YwwBlock"
                             v-if="isRcolorTypeshow">
                          <span rel="0.00"
                                v-for="(item,index) in RcolorType[type2].list"
                                :key="index"
                                @click="chooseColor2(index,item)"
                                :class="{'cur':item.imageid==Rnumber1}">
                            <img :src=" httpurl +item.image"
                                 :title="item.title"
                                 width="65"
                                 height="65">
                          </span>

                        </div>

                        <p class="pro_cankao">*颜色仅供参考，以实物为准。</p>
                      </div>
                    </div>
                  </div>
                </dt>
                <dd>
                  <div class="pro_listleft">
                    <span v-html="productlist.content">
                      {{productlist.content}}
                    </span>

                  </div>
                  <div class="pro_listright">
                    <span v-if="ukey==0||this.$route.query.productmoreid">￥{{sum| toFixed(2)}}</span>
                     <span v-if="ukey!=0&&this.$route.query.discount">￥{{sum*discount| toFixed(2)}}</span>
                    <span v-if="ukey!=0&&!this.$route.query.discount&&!this.$route.query.productmoreid">￥{{sum*discount| toFixed(2)}}</span>
                 <!-- <span v-if="twice">￥{{sum| toFixed(2)}}</span> -->
                    <a href="javascript:;"
                       class="linkNext"
                       @click="box()">选择线材</a>
                  </div>

                </dd>
              </dl>

              <dl></dl>
            </div>
          </div>
        </div>

      </div>
    </div>
  </body>
</template>
<script>
// import { ColorList } from '../../api/api'
import red from "../assets/2019092409082220.png";
import { mapActions, mapGetters } from "vuex";
import myHeader from "@/views/detailimg";
import { type } from 'os';
import {  getpro,gzkxx,getPcolor } from "@/api/api";
export default {
  components: { myHeader },

  data () {
    return {

      productid: '',
      isLcolorTypeshow: false,//左耳颜色类型列表显示
      isRcolorTypeshow: false,//右耳颜色类型列表显示
      ColorList: {},
      httpurl: "http://shop.qdc.com/",
      daohang: false, //显示导航
      screenWidth: document.body.clientWidth, // 屏幕尺寸
      number1: '',
      Rnumber1: '',
      earid: 1,
      earType: {},
      typeid: 1,
      translucent: true,
      notranslucent: false,
      ear: 1,
      type: 1,
      type2: 1,
      number: 0,
      addprice: 0.00,
      addLprice: 0.00,
      addRprice: 0.00,
      YwwpicRight: {},
      YwwLagre: {},
      productlist: '',
      productname: '',
      name: "",
      LcolorType: [],
      RcolorType: [],
      Rtypeid: 1,
      sum: '',
      ukey:0,
      productprice: '',
      discount:1,
      loading:false,
    //   twice:false,
    };
  },

  created () {
     if(this.$route.query.discount){
 this.discount =this.$Base64.decode(this.$route.query.discount)
     }
      
    //  Object.assign(this.YwwpicRight,res.data.ColorList[1].class[1].list[0])
    //  Object.assign(this.YwwLagre,res.data.ColorList[2].class[1].list[0])
         this.getukey();    
   
    window.screenWidth = document.body.clientWidth;
    this.daohang = window.screenWidth > 1024 ? true : false;
   
    if (localStorage.getItem("prpductnewlist") != null) {
      var list = JSON.parse(localStorage.getItem('prpductnewlist'));
      this.productlist = list
      this.sum = list.price
      this.productprice = list.price
      this.productid = list.id
    }
    if (localStorage.getItem("newChildproductlist") != null) {
      var list2 = JSON.parse(localStorage.getItem('newChildproductlist'));
      this.productname = list2.name
    }

    this.getcolor();
  },
  mounted () {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;

        this.daohang = window.screenWidth > 1024 ? true : false;
      })();
    };
  },

  computed: {
    //通过点击按钮显示移动端导航
    showdao () {
      this.daohang = !this.daohang;
    },
    //跳转产品页面
    Toproduct () {
      this.$router.push("/");
      if (window.screenWidth < 1024) {
        this.daohang = !this.daohang;
      }
    },
    //跳转设计页面
    ToDesign () {
      this.$router.push("/Design");
    },

  },
  methods: {
      getukey(){
if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
        this.ukey = 0
      }else{
          this.ukey=localStorage.getItem('newukey')
          
      }
 
     this.loading=true
   this.twicegm()
      },
    twicegm(){
        if(this.$route.query.productmoreid){
    this.getproductlist()
    
}else{
 
  if(this.ukey!=0){
     
      if(!this.$route.query.discount){
    this.getproductlist()
      }
    
     
}
}

    },
getproductlist () {
      var para = {
        id: this.$route.query.childid
      };
    //   console.log(para)

     getpro(para).then(res => {
       
//  if(!this.$route.query.discount||localStorage.getItem('discount')==null ||localStorage.getItem('discount')==1){
//      console.log('555555')
//      this.gzkxxList()
//       }
        
         
 

    
     
         this.productname=res.data.pro.parentname
        // console.log("产品详情列表请求成功", res.data);
// this.cpxxshow=true
        // this.productmessageList = res.data.pro
        // console.log(this.$route.query.productmoreid)
        if (this.$route.query.productmoreid == 1) {
          this.sum =  res.data.pro.cprice
          this.productprice= res.data.pro.cprice
        }
         else if (this.$route.query.productmoreid == 2) {
          this.sum =  res.data.pro.aprice
           this.productprice= res.data.pro.aprice
        //   this.discount= res.data.pro.abfb
        } 
        else if(this.$route.query.productmoreid == 3) {
          this.sum =  res.data.pro.bprice
           this.productprice= res.data.pro.bprice
        //    this.discount= res.data.pro.bbfb
        //    console.log("res.data.pro.bprice:"+res.data.pro.bprice)
        }else{
    //    console.log('AAA:::'+localStorage.getItem("discount"))
            this.sum= res.data.pro.price
             this.productprice= res.data.pro.price
            
              if (localStorage.getItem("discount") != null) {
                   var ifzkprice=localStorage.getItem("discount")

              }
            
              
        }
 this.$store.dispatch("ChangeProductlist", res.data.pro);
        res => {
          console.info("调用失败", res);
        };
      });
       
    },
     gzkxxList () {
      var para = {
        token: sessionStorage.getItem('token'),
        ukey: this.ukey,
      };
      gzkxx(para).then(res => {
        if (res.data.error_code == 200) {
          
              this.discount=res.data.zk
            // this.zhprice = res.data.zk * parseFloat(this.productList.price)
            localStorage.setItem('discount', res.data.zk)
        

        

        } else {
          console.info("调用失败", res);
        }
      }).catch(err => { console.info("调用失败", err); })
    },

     getcolor () {
      var para = {
        id: this.$route.query.childid
      };
      getPcolor(para).then(res => {
        if (res.data.error_code == 200) {
            this.isLcolorTypeshow = true;
          this.isRcolorTypeshow = true;
        //   console.log(res)
          this.earType = res.data.ColorList;
          this.LcolorType = res.data.ColorList[1].class;
        //   LcolorType[1].list.forEach(el => {
        //       el.image = this.httpurl + el.image
        //   })
        //   this.LcolorType = LcolorType
        //   console.log(this.LcolorType[1].list)
          this.RcolorType = res.data.ColorList[2].class;
        //   this.YwwpicRight = res.data.ColorList[1].class[1].list[0];
        //   this.YwwLagre = res.data.ColorList[2].class[1].list[0];
         Object.assign(this.YwwpicRight,res.data.ColorList[1].class[1].list[0]);
         Object.assign(this.YwwLagre,res.data.ColorList[2].class[1].list[0]);
          // this.RcolorType=res.data.ColorList[2].class;
          //   this.Ltranslucent=res.data.ColorList[2].class[1].list;
        } else {
          console.info("调用失败", res);
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    
    // getcolor () {
       
    //   this.$axios({
    //     method: "post",
    //     url: "/index/getcolor",
    //     headers: {
    //       "Content-type": "application/x-www-form-urlencoded"
    //     },
    //     data: {
    //       //   id:  JSON.parse(localStorage.getItem('prpductnewlist')).id
    //       id: this.$route.query.childid
    //     },
    //     transformRequest: [
    //       function (data) {
    //         let ret = "";
    //         for (let it in data) {
    //           ret +=
    //             encodeURIComponent(it) +
    //             "=" +
    //             encodeURIComponent(data[it]) +
    //             "&";
    //         }
    //         return ret;
    //       }
    //     ]
    //   }).then(res => {
    //     if (res.data.error_code == 200) {
    //       this.isLcolorTypeshow = true;
    //       this.isRcolorTypeshow = true;
    //     //   console.log(res)
    //       this.earType = res.data.ColorList;
    //       this.LcolorType = res.data.ColorList[1].class;
    //     //   LcolorType[1].list.forEach(el => {
    //     //       el.image = this.httpurl + el.image
    //     //   })
    //     //   this.LcolorType = LcolorType
    //     //   console.log(this.LcolorType[1].list)
    //       this.RcolorType = res.data.ColorList[2].class;
    //     //   this.YwwpicRight = res.data.ColorList[1].class[1].list[0];
    //     //   this.YwwLagre = res.data.ColorList[2].class[1].list[0];
    //      Object.assign(this.YwwpicRight,res.data.ColorList[1].class[1].list[0]);
    //      Object.assign(this.YwwLagre,res.data.ColorList[2].class[1].list[0]);
    //       // this.RcolorType=res.data.ColorList[2].class;
    //       //   this.Ltranslucent=res.data.ColorList[2].class[1].list;
    //     } else {
    //       console.error("获取getcolor失败");
    //     }
    //   });
    // },
    returnmix () {
      this.$router.push("/");
    },
    product () {
      this.$router.push("/");
    },
    box () {
     
      if (this.number1 == '' || this.Rnumber1 == '') {
        this.$message({
          message: "请选择左右耳颜色",
          type: 'error'
        });
        return;
      }
      if(this.$route.query.childid&&this.ukey==0&&this.$route.query.productmoreid){
        
          this.$router.push({
        path: '/PurchaseFusionBox',
        query: {
          //    childid: item.id
        //   newsum: this.sum,   
           newsum: this.$Base64.encode(this.sum),
          productmoreid:this.$route.query.productmoreid,
            
        }
      }); 
      }
      if(this.ukey==0){
       if(this.$route.query.productmoreid){
       
          this.$router.push({
        path: '/PurchaseFusionBox',
        query: {
          //    childid: item.id
        //   newsum: this.sum,   
          newsum: this.$Base64.encode(this.sum),
          productmoreid:this.$route.query.productmoreid,
            
        }
      }); 
      } else{
  this.$router.push({
        path: '/PurchaseFusionBox',
        query: {
          //    childid: item.id
        //   newsum: this.sum,   
         
              newsum: this.$Base64.encode(this.sum),
        }
      }); 
      }
        
      }
      
      
     if(this.$route.query.productmoreid){
       
          this.$router.push({
        path: '/PurchaseFusionBox',
        query: {
          //    childid: item.id
        //   newsum: this.sum,   
          newsum: this.$Base64.encode(this.sum),
          productmoreid:this.$route.query.productmoreid,
            
        }
      }); 
      } 
     else{
        
this.$router.push({

        path: '/PurchaseFusionBox',
        query: {
          //    childid: item.id
        //   newsum:this.sum* this.discount,
          newsum: this.$Base64.encode(this.sum* this.discount),
          ukey:  this.ukey
        }

      });
      }
      localStorage.setItem('discount',this.discount)
      localStorage.setItem('addprice',this.addprice)
    },
    // box() {

    //   this.$router.push({ path: "/PurchaseFusionBox" });
    //   // this.$store.dispatch('ChangeYwwLagre',{YwwLagre})
    //   // this.$store.dispatch('ChangeYwwpicRight',{YwwpicRight})
    // },
    handleEarType (index, id) {
      this.ear = index;
      this.earid = id;
      //				console.log(this.typeid)
    },
    handleColorType (index, id) {
      this.type = index;
      //   this.type1 =0;
      this.typeid = id;
    },
    handleColorType2 (index, id) {
      this.type2 = index;
      //  this.type =0;
      this.Rtypeid = id;
    },
    chooseColor (index, item) {
      let LcolorType = this.LcolorType
    //   console.log(this.sum)
    //   this.LcolorType[1].list,
    //   console.log('赋值前的第一个图片：',this.LcolorType[1].list[0].image)
      this.number1 = item.imageid;     
      this.YwwpicRight.image = item.image
    //   console.log('当前点击的图片：',item.image)
    //   console.log('赋值后的第一个图片：',this.LcolorType[1].list[0].image)     
      this.addLprice=item.price     
      this.addprice=Math.max(this.addLprice, this.addRprice)     
    //   console.log("item.price     :"+item.price     )
    //   console.log(" this.addprice:"+ this.addprice     )
    if(this.ukey!=0&&this.$route.query.discount){
         this.sum = parseFloat(this.addprice) + parseFloat(this.productprice)
        //   console.log("this.sum:"+this.sum     )
        //    console.log("this.ukeya:"+this.ukey     )
    }
    
    
    else{
this.sum = parseFloat(this.addprice)*this.discount + parseFloat(this.productprice)
// console.log("this.sum:"+this.sum     )
//  console.log(" parseFloat(this.addprice):"+ parseFloat(this.addprice)    )
//  console.log("this.discount:"+ this.discount   )\
// console.log("this.ukeyb:"+this.ukey     )

    }
      
      this.$store.dispatch("ChangeYwwpicRight", item);
     
    },
    chooseColor2 (index, item) {
      this.Rnumber1 = item.imageid;  
      this.YwwLagre.image = item.image;
      this.addRprice=item.price
      this.addprice=Math.max(this.addLprice, this.addRprice)
   if(this.ukey!=0&&this.$route.query.discount){
         this.sum = parseFloat(this.addprice) + parseFloat(this.productprice)
    }else{
this.sum = parseFloat(this.addprice)*this.discount + parseFloat(this.productprice)
    }
      this.$store.dispatch("ChangeYwwLagre", item);

    }
  }
};
</script>

<style scoped>
@import "../../static/newlayout.css";
.pro_listleft p {
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/PurchaseFusion.vue